import styled from "styled-components";

export const ServicesTabs = styled.div`
  margin: auto;
  display: flex;
  gap: 8px;
  width: 80%;
  align-items: center;
  justify-content: space-evenly;
`;

export const ServiceTab = styled.button`
  background: #fff;
  border: none;
  display: grid;
  grid-column: auto / auto;
  gap: 0.3rem;
  place-items: center;
  width: 30%;
  padding: 10px;
  b {
    color: #101e8e;
  }
`;

export const ServicesContainer = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  place-items: center;
  gap: 1rem;
  padding-top: 12px;
  @media (max-width: 768px) {
    margin: auto;
    width: 90%;
    grid-template-columns: 1fr 1fr;
    justify-items: center;
  }
  @media (max-width: 400px) {
    grid-template-columns: 1fr;
  }
`;
export const ServicesCard = styled.div`
  width: 100%;
  height: 5rem;
  display: flex;
  color: #101e8e;
  font-weight: bold;
  background: #fff;
  justify-content: space-between;
  padding: 1rem;
  font-size: auto;
  align-items: flex-end;
  svg {
    align-self: flex-start;
  }
`;
